import { c as _c } from "react/compiler-runtime";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { useTeamMenuOptions } from "@pages/members/teams/use-team-menu-options";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { Box, Stack } from "@mui-wrapper";
import { generateTeamDetailsRoute } from "@router/router-helper";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { useTeamsPageBulkActions } from "@pages/members/teams/use-teams-page-bulk-actions";
import { formatUserRoleType, nounPluralize } from "@utils/data-display";
import { useDateTime } from "@hooks/use-date-time";
import { NO_TRANSLATE_CLASS, TeamIcon } from "@flat-ui";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { useMemo } from "react";
import { SkeletonMemberListItemCard } from "@components/common/mobile/skeleton-member-list-item-card";
/**
 * Mobile-specific view for teams list with action bar and card layout.
 */
export function TeamsMobileView(t0) {
  const $ = _c(27);
  const {
    teams,
    isLoading,
    sortBy,
    shouldExcludeRemove,
    memberToRemove
  } = t0;
  let t1;
  if ($[0] !== memberToRemove || $[1] !== shouldExcludeRemove) {
    t1 = {
      shouldExcludeRemove,
      memberToRemove
    };
    $[0] = memberToRemove;
    $[1] = shouldExcludeRemove;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const menuItems = useTeamMenuOptions(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("teams");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedEntities = useAppSelector(t2);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const {
    formatDate
  } = useDateTime();
  let t3;
  if ($[4] !== teams) {
    t3 = teams.map(_temp);
    $[4] = teams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const allTeamIds = t3;
  const t4 = selectedSdbCompany?.id ?? "";
  let t5;
  if ($[6] !== shouldExcludeRemove || $[7] !== t4 || $[8] !== teams) {
    t5 = {
      companyId: t4,
      teams,
      shouldExcludeRemove
    };
    $[6] = shouldExcludeRemove;
    $[7] = t4;
    $[8] = teams;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const bulkActionsButtons = useTeamsPageBulkActions(t5);
  if (!selectedSdbCompany) {
    return null;
  }
  let t6;
  if ($[10] !== formatDate || $[11] !== menuItems || $[12] !== selectedSdbCompany.id) {
    t6 = team_0 => {
      const creationDate = formatDate(team_0.createdAt);
      const role = formatUserRoleType(team_0.role);
      const membersCount = nounPluralize({
        counter: team_0.memberCount,
        word: "member"
      });
      const secondaryText = `${role} • ${membersCount}`;
      return <Box key={team_0.id}><ListItemCardMobile item={team_0} image={<Stack sx={{
          justifyContent: "center"
        }}><SphereAvatar icon={<TeamIcon sx={{
            width: "20px",
            height: "20px"
          }} />} size="small" shouldHideWhiteRim={true} backgroundColor={teamDisplayProperties[team_0.category.kind].color} /></Stack>} title={<span className={NO_TRANSLATE_CLASS}>{team_0.name}</span>} href={generateTeamDetailsRoute(selectedSdbCompany.id, team_0.id)} subtitle={`Created: ${creationDate}`} secondaryText={secondaryText} menuItems={menuItems} /></Box>;
    };
    $[10] = formatDate;
    $[11] = menuItems;
    $[12] = selectedSdbCompany.id;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isLoading || $[15] !== sortBy || $[16] !== t6 || $[17] !== teams) {
    t7 = <VirtualizedGrid key={sortBy} items={teams} isLoading={isLoading} renderSkeletonItem={_temp2} estimateSize={112} shouldMeasureRowHeight={true} renderItem={t6} />;
    $[14] = isLoading;
    $[15] = sortBy;
    $[16] = t6;
    $[17] = teams;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== allTeamIds || $[20] !== bulkActionsButtons || $[21] !== isLoading || $[22] !== selectedEntities.length) {
    t8 = <FaroTableBulkActions bulkActionsButtons={bulkActionsButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allTeamIds} />;
    $[19] = allTeamIds;
    $[20] = bulkActionsButtons;
    $[21] = isLoading;
    $[22] = selectedEntities.length;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp2(index) {
  return <Box key={index}><SkeletonMemberListItemCard /></Box>;
}
function _temp(team) {
  return team.id;
}